import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Button, TextField, Box, Stack} from 'views/components';
import {Translate, translate} from 'views/module';

const ResetPassword = (props) => {
  const [password, setPassword] = React.useState(''); ;
  const [rePassword, setRePassword] = React.useState('');

  const [isResetting, setIsResetting] = React.useState(false);

  const [numValid, setNumValid] = React.useState(0);

  const onClose = props.onClose;
  const resetPassword = props.resetPassword;

  React.useEffect(() => {
    const passwordValid = password.length >= 6 ? 1 : 0;
    const rePasswordValid = rePassword.length >= 6 ? 1 : 0;
    const passwordIsEqual = password === rePassword ? 1 : 0;
    setNumValid(passwordValid + rePasswordValid + passwordIsEqual);
  }, [password, rePassword]);

  const onSubmit = (e) => {
    setIsResetting(true);
    resetPassword(password);
  };

  return (
    <Dialog onClose={onClose} open={true}>
      <DialogTitle onClose={onClose}>
        <Translate expression='caregiver.CaregiverDetail.Settings.Auth.ResetPassword' />
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            m: 1,
          }}
        >
          <Stack spacing={2}>
            <TextField
              type="password"
              value={password}
              onChange={setPassword}
              label={translate('caregiver.CaregiverDetail.Settings.Auth.Password')}
              fullWidth
              InputLabelProps={{shrink: true}}
            />
            <TextField
              type="password"
              value={rePassword}
              onChange={setRePassword}
              label={translate('caregiver.CaregiverDetail.Settings.Auth.RePassword')}
              fullWidth
              InputLabelProps={{shrink: true}}
            />
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={onClose}
        >
          <Translate expression='generic.Close' />
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={onSubmit}
          disabled={!(numValid === 3)}
          loading={isResetting}
        >
          <Translate expression='caregiver.CaregiverDetail.Settings.Auth.ResetPassword' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ResetPassword.propTypes = {
  onClose: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired,
};

export default React.memo(ResetPassword);
